import styled from 'styled-components';

export const MaterialTabList = styled.div`
    display: flex;
    align-items: stretch;
    flex-wrap: nowrap;
    flex-shrink: 0;
    width: 100%;
    position: relative;
    z-index: 6;
    overflow-x: auto;
    border: none;
    border-radius: 0;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16);
`;

export const MaterialTabButton = styled.button.withConfig({
    shouldForwardProp: (prop) => prop !== 'isActive'
})<{ isActive: boolean }>`
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    gap: 0 12px;
    min-width: 90px;
    min-height: 48px;
    margin: 0;
    padding: 12px 20px;
    border: none;
    border-radius: 0;
    background-color: #fff;
    color: ${({ isActive }) => isActive ? 'var(--color-site-secondary)' : 'var(--color-txt-secondary)'};
    cursor: pointer;
    white-space: nowrap;
    font: inherit;
    font-size: 14px;
    font-weight: ${({ isActive }) => isActive ? 700 : 500};
    line-height: 1.5;
    transition: color 0.2s ease;

    &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 4px;
        background-color: ${({ isActive }) => isActive ? 'var(--color-site-secondary)' : 'transparent'};
    }

    &:hover {
        color: var(--color-site-secondary);
    }

    &:focus-visible {
        outline: 2px solid var(--color-site-secondary);
        outline-offset: -4px;
    }
`;

export const MaterialTabText = styled.span`
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    white-space: nowrap;
`;
